// Simple utility for API URLs with centralized locale handling
const API_BASE_URL =
  process.env.NEXT_PUBLIC_STRAPI_API_URL || "http://localhost:1337";

export function getApiUrl(
  endpoint: string,
  locale?: string,
  params?: Record<string, string | number>
) {
  const baseUrl = `${API_BASE_URL}/api${endpoint}`;
  const searchParams = new URLSearchParams();

  if (locale) {
    searchParams.append("locale", locale);
  }

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, value.toString());
      }
    });
  }

  return `${baseUrl}${
    searchParams.toString() ? `?${searchParams.toString()}` : ""
  }`;
}

// Helper for fetch with error handling
export async function fetchApi<T>(
  url: string,
  options?: { revalidate?: number }
): Promise<T> {
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
    // Enable caching for production, use revalidate for static generation
    next: options?.revalidate
      ? { revalidate: options.revalidate }
      : { revalidate: 1 },
  });
  const result = await response.json();
  return result;
}
